// manageStudentsActions.js
import api from "../../lib/api/api";
import {
  FETCH_MANAGE_COURSES_FAILURE,
  FETCH_MANAGE_COURSES_REQUEST,
  FETCH_MANAGE_COURSES_SUCCESS,
} from "../Actions/types";

export const fetchEnrolledCoursesByTeacherId = () => async (dispatch) => {
  dispatch({ type: FETCH_MANAGE_COURSES_REQUEST });
  try {
    const response = await api.get(`/enrollment/manage-students`);
    dispatch({
      type: FETCH_MANAGE_COURSES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_MANAGE_COURSES_FAILURE,
      payload: error.message,
    });
  }
};
